<template>
	<div>
		<v-form ref="form" v-model="isFormValid" lazy-validation>
			<modal
				:exibir="exibir"
				:titulo="tituloModal"
				:max-width="larguraModal"
				:is-confirmar-visivel="isConfirmarVisivel"
				:custom-actions="false"
				:acao-cancelar="fecharModal"
				:acao-confirmar="tratarEventoEstornar"
				nome-botao-confirmar="Estornar"
				:nome-botao-cancelar="nomeBotaoCancelar"
				:tamanho="{ largura: larguraModal }"
				@close="fecharModal"
			>
				<template #body>
					<div class="my-1">
						<estornar-item-adesao
							v-if="isEstornar"
							:itens="itens"
							:lista-possui-um-item="listaPossuiUmItem"
							@limpar-formulario="recarregarFormulario"
						></estornar-item-adesao>
						<historico-estorno-item-adesao
							v-else
							:item-selecionado="itens[0]"
						></historico-estorno-item-adesao>
					</div>
				</template>
			</modal>
		</v-form>
		<modal-confirmacao
			titulo-modal="Cancelar documento no processo digital"
			:exibir="exibirConfirmacaoCancelarDocumento"
			subtitulo-modal="Deseja cancelar o documento antigo automaticamente no processo digital?"
			@confirmar="estornar(true)"
			@fechar-modal="estornar(false)"
		>
		</modal-confirmacao>
	</div>
</template>

<script>
import EstornarItemAdesao from '@/views/pages/adesao/aderente/itens/estorno/estornar/EstornarItemAdesao.vue'
import HistoricoEstornoItemAdesao from '@/views/pages/adesao/aderente/itens/estorno/historico/HistoricoEstornoItemAdesao.vue'
import Modal from '@/views/components/Modal.vue'
import { actionTypes, mutationTypes } from '@/core/constants'
import { mapState } from 'vuex'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'

export default {
	name: 'modal-estorno-item-adesao',
	components: { ModalConfirmacao, Modal, EstornarItemAdesao, HistoricoEstornoItemAdesao },
	props: {
		itens: {
			type: Array,
			required: true,
		},
		exibir: {
			type: Boolean,
		},
		isEstornar: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			isFormValid: false,
			exibirConfirmacaoCancelarDocumento: false,
		}
	},
	computed: {
		...mapState({
			formulario: (state) => state.adesao.itensAdesao.estorno.estornar.form,
			isProcessoDigitalAtivo: (state) => state.parametrosSistema.isProcessoDigitalAtivo,
			idAdesao: (state) => state.adesao.informacoesAdesao.id,
			isOrdemUtilizacaoGerada: (state) => state.adesao.informacoesAdesao.isOrdemUtilizacaoGerada,
		}),
		quantidadeEstornoIsValid() {
			return (this.itens.length === 1 && this.formulario.quantidadeEstorno > 0) || this.itens.length > 1
		},
		justificativaValida() {
			return !!this.formulario.justificativa && this.formulario.justificativa.trim().length > 0
		},
		isConfirmarVisivel() {
			return this.isEstornar && this.isFormValid && this.quantidadeEstornoIsValid && this.justificativaValida
		},
		tituloModal() {
			return this.isEstornar ? 'Estornar' : 'Detalhes Estorno'
		},
		nomeBotaoCancelar() {
			return this.isEstornar ? 'CANCELAR' : 'VOLTAR'
		},
		listaPossuiUmItem() {
			return this.itens.length === 1
		},
		larguraModal() {
			return this.isEstornar ? '600' : '800'
		},
	},
	methods: {
		tratarEventoEstornar() {
			if (this.$refs.form.validate()) {
				if (this.isOrdemUtilizacaoGerada) {
					this.abrirModalConfirmacaoCancelarDocumento()
				} else {
					this.estornar(false)
				}
			}
		},
		fecharModalConfirmacaoCancelarDocumento() {
			this.exibirConfirmacaoCancelarDocumento = false
		},
		abrirModalConfirmacaoCancelarDocumento() {
			this.exibirConfirmacaoCancelarDocumento = true
		},
		async estornar(cancelarDocProcessoDigital) {
			if (this.$refs.form.validate()) {
				await this.$store
					.dispatch(actionTypes.ADESAO.ESTORNO.ESTORNAR.ESTORNAR_ITEM, {
						cancelarDocProcessoDigital,
						idAdesao: this.idAdesao,
					})
					.then(() => {
						this.recarregarFormulario()
						this.limparSelecaoItensExterno()
						this.mostrarNotificacaoSucessoDefault()
						this.fecharModalConfirmacaoCancelarDocumento()
						this.fecharModal()
					})
					.catch(() => this.fecharModalConfirmacaoCancelarDocumento())
			}
		},
		fecharModal() {
			this.$emit('fechar-modal')
			this.$emit('carregar-listagem')
		},
		recarregarFormulario() {
			this.$refs.form.reset()
			this.$store.commit(mutationTypes.ADESAO.ITENS.ESTORNO.ESTORNAR.RESET_FORM)
		},
		limparSelecaoItensExterno() {
			if (!this.listaPossuiUmItem) {
				this.$store.commit(mutationTypes.ADESAO.ITENS.RESET_ITENS_SELECIONADOS)
				this.$store.commit(mutationTypes.ADESAO.ITENS.SET_TODOS_ITENS_SELECIONADOS, false)
			}
		},
	},
}
</script>
